/**
 * packages/server/src/ws-gateway.ts
 *
 * Re-export from platform/src/ws-gateway.ts — 단일 소스 유지.
 *
 * ⚠️ 실제 구현은 packages/platform/src/ws-gateway.ts 에만 존재.
 *     수정 시 반드시 platform 쪽을 수정할 것.
 *
 * NOTE: Bun 런타임에서 직접 실행되므로 .ts 확장자 사용.
 *       tsconfig rootDir 제약이 있어 상대 경로 re-export 대신
 *       런타임 dynamic import로 우회. (빌드 대상 아님)
 */
import { resolve, dirname } from "path";
import { fileURLToPath } from "url";

const __dirname = dirname(fileURLToPath(import.meta.url));
const platformWsGateway = resolve(__dirname, "../../platform/src/ws-gateway.ts");

// 런타임 import (Bun에서 .ts 직접 실행)
const mod = await import(platformWsGateway);

export const handleOpen = mod.handleOpen;
export const handleMessage = mod.handleMessage;
export const handleClose = mod.handleClose;
export const notifyEmit = mod.notifyEmit;
export const notifyInvalidate = mod.notifyInvalidate;
export const notifyQueryInvalidate = mod.notifyQueryInvalidate;
export const notifyQueryRevoke = mod.notifyQueryRevoke;
export const notifyChannelPublish = mod.notifyChannelPublish;
export const notifyChannelInvalidate = mod.notifyChannelInvalidate;
export const notifyChannelRevoke = mod.notifyChannelRevoke;
export const getConnectionCount = mod.getConnectionCount;
export const getStats = mod.getStats;
export const getGatewayLimits = mod.getGatewayLimits;
export const consumeRealtimeNotifyRateLimit = mod.consumeRealtimeNotifyRateLimit;
export const consumeGatewayRealtimeTicket = mod.consumeGatewayRealtimeTicket;
export const isLocalInternalHost = mod.isLocalInternalHost;
export const authorizeRealtimeNotifyRequest = mod.authorizeRealtimeNotifyRequest;
export const resetGatewayForTests = mod.resetGatewayForTests;
export const startHeartbeat = mod.startHeartbeat;
